import React from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import { Box, Typography } from "@material-ui/core";
import EditText from "../../components/EditText";
import Submit from "../../components/Submit";
import { useTranslation } from "react-i18next";

const validationSchema = Yup.object().shape({
  username: Yup.string().required("Is required"),
});

const ResetForm = ({ initialValues, onSubmit = () => {} }) => {
  const { t } = useTranslation();

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {(props) => (
        <form onSubmit={props.handleSubmit}>
          <Box mb={1}>
            <Typography color="textPrimary" variant="h2">
              {t("reset.title")}
            </Typography>
          </Box>
          <Box mb={1}>
            <Typography>{t("reset.text")}</Typography>
          </Box>
          <EditText {...props} label={t("reset.username")} name="username" />
          <Box my={2}>
            <Submit {...props} title={t("reset.button")} />
          </Box>
        </form>
      )}
    </Formik>
  );
};

export default ResetForm;
